import { cva, VariantProps } from "class-variance-authority"

import { CheckmarkCircleIcon, InfoSquareIcon, WarningSquareIcon } from "@/domains/icons"
import { cn } from "@/domains/library"

const messageBoxIconVariants = cva("text-t100", {
  variants: {
    variant: {
      error: "text-error-text",
      info: "text-t300",
      success: "text-success-text",
    },
    size: {
      xxs: "",
      xs: "",
      sm: "",
      md: "",
      lg: "",
    },
  },
  defaultVariants: {
    variant: "info",
    size: "sm",
  },
})

export interface MessageBoxIconProps extends VariantProps<typeof messageBoxIconVariants> {
  className?: string
}

export function MessageBoxIcon({ variant = "info", size = "sm", className }: MessageBoxIconProps) {
  let iconSize = 16
  let strokeWidth = 1.2
  switch (size) {
    case "xs":
      iconSize = 16
      break
    case "sm":
      iconSize = 18
      break
    case "md":
      iconSize = 22
      strokeWidth = 1.4
      break
    case "lg":
      iconSize = 24
      strokeWidth = 1.4
      break
  }

  const classes = cn(messageBoxIconVariants({ variant, size }), className)

  switch (variant) {
    case "info":
      return <InfoSquareIcon className={classes} strokeWidth={strokeWidth} size={iconSize} />
    case "success":
      return <CheckmarkCircleIcon className={classes} size={iconSize} />
    case "error":
      return <WarningSquareIcon className={classes} size={iconSize} />
  }
}
